import { Stack } from "@mui/material";
import { useContext } from "react";
import { useGetUnknownDetailTransactions } from "src/services/admin/queries/unknownDetailTransactions";

import Context from "../context";
import TransactionRow from "./TransactionRow";

export default function TransactionDetail() {
	const { state } = useContext(Context);

	const { data } = useGetUnknownDetailTransactions(state.id ?? "");

	return (
		<Stack sx={{ p: 3 }}>
			{data?.map((i, index) => {
				return <TransactionRow key={index} row={i} />;
			})}
		</Stack>
	);
}
